<template>
    <jet-section>
        <template #title>
            Referrals
        </template>
        <template #description>
            Get 250 Stars each for all new users that click this link and complete registration:<br /><br />

            <span class="text-gray-800 dark:text-racing-stars-yellow inline-block cursor-pointer" @click="copy">{{ user.referral_link }}</span> <ClipboardIcon class="h-6 w-6 text-gray-800 dark:text-racing-stars-yellow cursor-pointer inline-block" aria-hidden="true" @click="copy" />

            <span class="transition duration-500 ease-in-out inline-block mt-2">{{ copied }}</span>
        </template>
        <template #content>
            <div class="overflow-y-scroll shadow border-b border-gray-200 transition duration-500 ease-in-out dark:border-gray-800 sm:rounded-lg" v-if="user.referrals.length">
                <table class="border-collapse table-auto w-full divide-y divide-gray-200 table-auto">
                    <thead class="bg-gray-50 bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Username
                            </th>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Tokens Earned
                            </th>
                            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white">
                                Date Referred
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200">
                        <tr v-for="(referral, referralKey) in referrals" :key="referralKey" :class="referralKey % 2 === 0 ? 'bg-white transition duration-500 ease-in-out dark:bg-gray-600' : 'bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-800'" class="dark:hover:bg-opacity-80">
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm  text-left text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                    {{ referral.username }}
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white text-left">
                                <div class="text-sm text-left font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                    250
                                </div>
                            </td>
                            <td class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">
                                <div class="text-sm text-gray-900 transition duration-500 ease-in-out dark:text-white whitespace-pre-wrap">{{ moment(referral.created_at).format('dddd, MMMM Do, YYYY') }}</div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3" class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">Total Referrals: {{ Object.keys(user.referrals).length }}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="px-6 text-right py-4 whitespace-nowrap transition duration-500 ease-in-out dark:text-white">Total Tokens Earned: {{ Object.keys(user.referrals).length * user.referral_tokens }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div v-else>
                <alert type="info" class="mt-4">
                    <template #title>
                        No referrals Available!
                    </template>
                    <template #message>
                        You haven't referred any users yet.
                    </template>
                </alert>
            </div>
        </template>
    </jet-section>
</template>
<script>
import { ref } from 'vue'
import JetSection from '@/Jetstream/Section.vue'
import JetButton from '@/Jetstream/Button.vue'
import TwTable from '@/Global/Elements/TwTable.vue'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import { ClipboardIcon } from '@heroicons/vue/outline'
import useClipboard from 'vue-clipboard3'
import Alert from '@/Global/Alert.vue'
import moment from 'moment'

export default {
    components: {
        JetSection,
        JetButton,
        TwTable,
        RacingStarsIcon,
        ClipboardIcon,
        Alert,
    },

    props: {
        user: Object,
        referrals: Object
    },

    setup(props) {
        const { toClipboard } = useClipboard()
        const copied = ref(null)

        const copy = async () => {
            try {
                await toClipboard(props.user.referral_link)

                copied.value = 'Referral link copied to clipboard!'

                setTimeout(e => {
                    copied.value = null
                }, 2000)
            } catch (e) {
                console.error(e)
            }
        }

        return {
            moment,
            copy,
            copied,
        }
    }
}

</script>
